import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { actionReporterMiddleware, cventAnalyticsReporter } from 'nucleus-analytics-middleware';
import createFactProvider from './analytics/createFactProvider';

/**
* Function to create the store for a site editor application.
*/
export default function createStoreWithMiddleware(
    reducer,
    initialState,
    { analyticsConfig = { enabled: false, appId: '', baseUrl: '' },
      optionalMiddleware = [],
      optionalEnhancers = [] } = {}) {
  // Set up the internal middleware according to the passed in configuration.
  const internalMiddleware = [thunkMiddleware];
  if (analyticsConfig && analyticsConfig.enabled && analyticsConfig.appId && analyticsConfig.baseUrl) {
    const url = analyticsConfig.baseUrl.concat(analyticsConfig.endpoint || 'api/analytics/batchfacts');
    internalMiddleware.unshift(
      actionReporterMiddleware({
        factProvider: createFactProvider(analyticsConfig),
        analyticsReporter: cventAnalyticsReporter(url, {
          authToken: analyticsConfig.authToken,
          withCookies: analyticsConfig.withCookies
        })
      }));
  }
  // Set up the internal enhancers according to the passed in configuration.
  const internalEnhancers = [];

  // Create the store, applying our internal middleware, any optionally passed in
  // middleware, any optionally passed in enhancers, and our internal enhancers.
  const getStore = compose(
    applyMiddleware(
      ...internalMiddleware,
      ...optionalMiddleware),
    ...optionalEnhancers,
    ...internalEnhancers
  )(createStore);

  return getStore(reducer, initialState);
}
